import React from "react";
import "./index.scss";
import { Controller } from "react-hook-form";

const Input = ({
  type = "text",
  placeholder,
  onInputChange = undefined,
  name,
  rules,
  required = true,
  disabled = false,
  control,
  errors,
  suffix = null,
  prefix = null,
  className = "",
  label = "",
  defaultValue = "",
  min,
  max,
  ...props
}) => {
  return (
    <div className={`input-group ${className}`}>
      {label && <label>{label}</label>}
      <div className="input-field">
        {prefix && (
          <div className="input--prefix">
            {typeof prefix === "function" ? prefix() : prefix}
          </div>
        )}
        <Controller
          name={name}
          control={control}
          rules={rules}
          defaultValue={defaultValue}
          render={({ field: { onChange, value = "" } }) => (
            <input
              type={type}
              required={required}
              disabled={disabled}
              placeholder={placeholder}
              onChange={(e) => {
                onChange(e);
                if (onInputChange) {
                  onInputChange(e);
                }
              }}
              value={value}
              // min={min}
              // max={max}
              minLength={min} // Ensures minimum length validation
              maxLength={max} // Ensures maximum length validation
              className={`form-control ${errors[name] ? "input__invalid" : ""}`}
              {...props}
            />
          )}
        />
        {suffix && (
          <div className="input--suffix">
            {typeof suffix === "function" ? suffix() : suffix}
          </div>
        )}
      </div>
      {errors && errors[name] && (
        <div className="input--helper__invalid">
          {errors[name]?.message}
        </div>
      )}
    </div>
  );
};

export default Input;
